import React, { useMemo } from "react";
import { Bar } from "react-chartjs-2";
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from "chart.js";
import { useSelector } from "react-redux";
import  useLocale  from "../../src/locales/index";
import i18n from "../i18n";
import { useTranslation } from "react-i18next";
import numberSuffixes from "../utiles/numberSuffixes";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const formatCurrency = (value) => {
  const language = i18n.language || "en-IN"; 
  return value
    ? Math.round(value).toLocaleString(language, {
        maximumFractionDigits: 0,
      })
    : "0";
};

const PensionBarChart = ({ totalInvestment, totalCorpus }) => {
  const { i18n } = useTranslation();
  const langCode = i18n.language || "default";
  const suffixSet = numberSuffixes[langCode] || numberSuffixes["default"];
  
  const { textData } = useLocale();

const { totalTaxSaving } = useSelector((state) => state.pensionCalculator);
  const barData = useMemo(() => {
    return {
      labels: [
        ` ${formatCurrency(totalInvestment)}`,
        ` ${formatCurrency(totalCorpus)}`,
           ], 
      datasets: [
        {
          label: "Total ",
          data: [totalInvestment, totalCorpus],
          backgroundColor: ["#57C6F4","#FF8566"],
          barThickness: 60,
          borderTopLeftRadius: 6,
          borderRadius: 6,
          borderTopRightRadius: 6
        },
        
      ],
    };
  }, [totalInvestment, totalCorpus]);

  const barChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: false 
      }
    },
    scales: {
      x: {
        grid: {
          display: false,
          drawBorder: false
        },
        border: {
          display: false
        },
        ticks: {
          color: "#000000",
          font: {
            size: 10
          }
        }
      },
      y: {
        beginAtZero: true,
        border: {
          display: false
        },
        grid: {
          color: "#EEEEEE",
          drawBorder: false,
          lineWidth: 1,
        },
        ticks: {
          padding: 10,
          // stepSize: stepSize,
          callback: function (value) {
            if (value >= 10000000) return (value / 10000000).toFixed(0) + suffixSet.crore;
            if (value >= 100000) return (value / 100000).toFixed(0) + suffixSet.lakh;
            if (value >= 1000) return (value / 1000).toFixed(0) + suffixSet.thousand;
            return value.toLocaleString(i18n.language);
          },  
          color: "#888888",
          font: {
            size: 10
          }
        }
      }
    },
    layout: {
      padding: {
        left: 0,
        right: 0,
        top: 20,
        bottom: 10
      }
    }
  };

  // Render financial metrics
  const renderFinancialMetrics = () => {
    const interestEarned = totalCorpus - totalInvestment;

    const metrics = [
      { 
        label: textData.chartLabels.totalInvestment,
        value: totalInvestment,
        color: "#57C6F4" ,
        borderBottom:'1px solid #DDE1E5'
      },
      { 
        label: textData.chartLabels.totalCorpus,
        value: totalCorpus,
        color: "#FF8566" ,
        borderBottom:'1px solid #DDE1E5'

      },
      { 
        label: textData.chartLabels.intrestEarned,   
             value: interestEarned,
        color: "#000000" 
      },
      { 
        label: textData.chartLabels.totalTaxSaving,     
           value: totalTaxSaving,
        color: "#000000" 
      }
    ];

    return (
      <div className="">
        {metrics.map((metric, index) => (
          <div key={index} className="flex items-center py-6 last:py-0 "
          style={{ borderBottom: metric.borderBottom }}>
            {index < 2 && (
              <div 
                className="h-5 w-5 mr-2 rounded-[4px]"
                style={{ backgroundColor: metric.color}}
              ></div>
            )}
            <div className="flex-grow text-left  text-sm sm:text-sm text-black flex  justify-between" 
            >
              {metric.label}
              <span className="font-medium"> {textData.currency}{metric.value
                ? Math.round(metric.value).toLocaleString(i18n.language || "en-IN")
                : "0"}
            </span>
            </div>
           
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className="mb-8 ">

      <div className="h-[320px]  w-[100%] sm:w-[85%] lg:w-[256px] flex justify-center mb-2 mx-auto">
        <Bar data={barData} options={barChartOptions} />
      </div>
      {renderFinancialMetrics()}
    </div>
  );
};

export default PensionBarChart;